import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessengerPage } from './messenger';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    MessengerPage,
  ],
  imports: [
    IonicPageModule.forChild(MessengerPage),
    ComponentsModule,
  ],
})
export class MessengerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/messenger/messenger.module.ts